import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ICourses } from '../courses';
import { GeneralService } from './general.service';
@Injectable()
export class ResultService {
  LineChart: any;
  public result_table;
  public session_table;
  public term_table;
  public term_details_table;

  constructor (
    private http: HttpClient,
    private general: GeneralService,
  ) { }

  getPrintHead (title) {
    // const fontUrl = this.sanitizer.bypassSecurityTrustUrl(`assets/fonts/nexaReg.otf`);
    // const href = "https://sibao.edossier.app/student-portal/#/home/term-report-sheets"
    const fontUrl = `${location.href.split("#")[0]}nexaReg.otf`;
    // console.log(fontUrl);

    return `<html>
      <head>
        <title>${title} </title>
        <script src="https://cdn.tailwindcss.com"> </script>
        <style>
          * {
            margin: 0;
            padding: 0;
          }
          @font-face {
            font-family: Nexa, sans-serif;
            src: url("${fontUrl}");
          }
          .font-nexa {
            font-family: Nexa, sans-serif
          }
          @media print {
            @page {
              margin: 0;
              size: auto;
            }
            body {
              margin: 0;
              padding: 0;
              
            }
            @page {
              @top-left {
                content: none;
              }
              @top-center {
                content: none;
              }
              @top-right {
                content: none;
              }
              @bottom-left {
                content: none;
              }
              @bottom-center {
                content: none;
              }
              @bottom-right {
                content: none;
              }
            }
          }
          th, td{
            border: 1px solid #ccc;
            padding: .5rem;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .cc {
            max-width: 180px;
          }
          .vert {
            transform: rotate(180deg);
            writing-mode: vertical-rl;
            white-space: nowrap;
          }
          .print-page {
            padding-top:1rem;
            page-break-after: always;
          }
          .print-page:last-child {
            page-break-after: auto;
          }
        </style>
      </head>
  `};

  //this is for the result chart

  // getResult() {
  //   let x = [3.5,4.0,1.0,4.5,4.9];
  //   this.LineChart = new Chart('lineChart',{
  //     type:'line',
  //     data:{
  //       labels:["100L","200L","300L","400L","500L"],
  //       datasets:[{
  //         label:"CGPA PROGRESS",
  //         data:x,
  //         fill:false,
  //         lineTension:0.2,
  //         borderColor:"red",
  //         borderWidth:1
  //       }]
  //     },
  //   })
  //   return this.LineChart;

  // }

  // getCourses(){
  //   let x = this._CourseCatalogue.getCourses();
  //   return x;
  // }

  sessionTable () {
    this.session_table = [
      { session_id: 1, session_year: "2017/2018", term_id: 1, status: 2 },
      { session_id: 2, session_year: "2018/2019", term_id: 2, status: 2 },
      { session_id: 3, session_year: "2019/2020", term_id: 1, status: 2 },
    ];
    return this.session_table;
  }
  resultTable () {
    this.result_table = [
      { r_id: 1, sub_id: 1, termd_id: 1, ca1: 20, ca2: 15, exam: 45, staff_id: 1 },
      { r_id: 2, sub_id: 1, termd_id: 1, ca1: 20, ca2: 15, exam: 45, staff_id: 1 },
      { r_id: 3, sub_id: 1, termd_id: 1, ca1: 20, ca2: 15, exam: 45, staff_id: 1 }
    ];
    return this.result_table;
  }

  // termTable(){
  //   this.term_table = [
  //     {term_id:1,term:"First Semester",session_id:1,begins:"2016-08-29",ends:"2017-03-31"},
  //     {term_id:2,term:"Second Semester",session_id:2,begins:"2017-04-01",ends:"2017-08-11"}
  //   ];
  //   return this.term_table;
  // }
  // TermDetailsTable(){
  //   this.term_details_table = [
  //     {termd_id:1,term_id:1,student_id:1},
  //     {termd_id:2,term_id:2,student_id:2},
  //     {termd_id:3,term_id:1,student_id:3}
  //   ];
  //   return this.term_details_table;
  // }

  loadCourses (): Observable<ICourses[]> {
    return this.http.get<ICourses[]>("/edozzier/portal-course-reg.php");
  }
  loadAllCourses (): Observable<ICourses[]> {
    return this.http.get<ICourses[]>("/edozzier/portal-all-courses.php");
  }
  regExtraCourse (extra) {
    return this.http.post<any>("/edozzier/portal-extra-courses.php", extra);
  }
  deleteCourse (id) {
    return this.http.post<any>("/edozzier/portal-delete-course.php", id);
  }

  registerCourses (da) {
    return this.http.post<any>("/edozzier/portal-course-reg2.php", da);
  }
  sem_reg_courses () {
    return this.http.get<any>("/edozzier/portal-sem-reg-courses.php");
  }
  semesterCourseRegPayments () {
    return this.http.get<any>("/edozzier/portal-sem-course-reg-payments.php");
  }

  regHistory () {
    return this.http.get<any>("/edozzier/portal-reg-history.php");
  }

  semesterResult () {
    return this.general.requestWithCache(
      this.http.get<any>("/edozzier/portal-semester-result.php"),
      { data: "results" }
    );
  }

  getSemesterInfo () {
    return this.http.get<any>("/edozzier/portal-semester-info.php");
  }

  checkSubscriptionStatus () {
    return this.http.get<any>("/edozzier/portal-check-subscription-status.php");
  }

  loadSummerSemesters () {
    return this.http.get<any>("/edozzier/portal-load-summer-semesters.php");
  }

  changeSemester (selectedSummerSemester) {
    return this.http.post<any>("/edozzier/portal-change-summer-semester.php", selectedSummerSemester);
  }

  getCurrentDate () {
    return this.http.get<any>("/edozzier/portal-get-date.php");
  }

  getGrades () {
    return this.http.get<any>("/edozzier/portal-get-grades.php");
  }

  checkResultPaymentStatus () {
    return this.http.get<any>("/edozzier/portal-check-result-payment.php");
  }

  payForResult (payment) {
    return this.http.post<any>("/edozzier/portal-pay-app-fees.php", payment);
  }
  payForLateRegistration (payment) {
    return this.http.post<any>("/edozzier/portal-pay-app-fees.php", payment);
  }

  companyRequiresResultPayment () {
    return this.http.get<any>("/edozzier/portal-company-requires-result-payment.php");
  }

  getReportConfig () {
    return this.http.get<any>("/edozzier/portal-get-report-config.php")
  }

  termReportSheets () {
    return this.http.get<any>("/edozzier/portal-term-report-sheets.php")
  }

  ResultEntrySettings (data = {}) {
    return this.http.post<any>("/edozzier/portal-resultEntrySettings.php", data);
  }

  weighedReportSheets () {
    return this.http.get<any>("/edozzier/portal-weighted-report-sheets.php")
  }


}
